import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LinkGroup from './LinkGroup';
import { BottomText, FooterWrapper } from './styled';
import { Mobile } from '../MediaQuery';
import withCountryCode from '../RoutesHoc/RoutesHoc';
import { promotionsPolicy } from '../../helpers/routes';
import { ItalistInfoBoxes } from '../ItalistInfoBoxes/ItalistInfoBoxes';
import SocialGroup from './SocialGroup/SocialGroup';
import NewsletterModalButton from '../NewsletterModalButton';
import { showChangeShippingCountry } from '../../modules/manageChangeShippingCountrySelector';
import { easeInOutQuint, scrollToY } from '../../helpers';

const mapStateToProps = ({ api: { country, footerData, s3BasePath } }) => ({
  country,
  footerData,
  s3BasePath,
});

const mapDispatchToProps = dispatch => ({
  showChangeShipping: () => dispatch(showChangeShippingCountry()),
});

const FooterComponent = ({ country, footerData, s3BasePath, buildUrlWithCountry, showChangeShipping }) => (
  <>
    <ItalistInfoBoxes />
    <FooterWrapper id="footer">
      <Mobile>
        <div style={{ padding: '0 2%' }}>
          <NewsletterModalButton />
        </div>
      </Mobile>
      <LinkGroup linkData={footerData} s3BasePath={s3BasePath} socialComp={<SocialGroup s3BasePath={s3BasePath} />} />
      <Mobile>
        <SocialGroup s3BasePath={s3BasePath} />
      </Mobile>
      <BottomText margin="20px auto">
        *Please refer to our &nbsp;<a href={buildUrlWithCountry(promotionsPolicy)}>Promotions Policy</a>&nbsp; for
        further details.
      </BottomText>
      <BottomText margin="25px auto 5px auto">
        You are shipping to&nbsp;
        <span
          data-cy="footer-shipping-country-label"
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={() => {
            scrollToY(0, 750, easeInOutQuint);
            setTimeout(() => showChangeShipping(), 150);
          }}
        >
          {country}
        </span>
      </BottomText>
      <BottomText>italist Inc.</BottomText>
    </FooterWrapper>
  </>
);

FooterComponent.propTypes = {
  country: PropTypes.string.isRequired,
  footerData: PropTypes.array.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  buildUrlWithCountry: PropTypes.func.isRequired,
  showChangeShipping: PropTypes.func.isRequired,
};

const Footer = connect(mapStateToProps, mapDispatchToProps)(FooterComponent);
export default withCountryCode(Footer);
